// cookies 用户id
export const USER_ID_COOKIES_KEY = 'USER_ID'

// cookies 用户token
export const USER_TOKEN_COOKIES_KEY = 'USER_TOKEN'
// cookies 广告id
export const AD_ID_COOKIES_KEY = 'AD_ID'

// localStorage 用户登录信息
export const USER_IS_LOGIN_STORE_KEY = 'USER_IS_LOGIN'
// localStoreage 用户是否购买vip
export const USER_IS_VIP_STORE_KEY = 'USER_IS_VIP'

// 是否是投放用户
export const IS_TOUFANG_STORE_KEY = 'IS_TOUFANG'

// 记录用户次数
export const USER_IMG_COUNT_STORE_KEY = 'USER_IMG_COUNT'

// 当前图片制作环节
export const USER_IMG_SEGMENT_STATUS_STORE_KEY = 'USER_IMG_SEGMENT_STATUS'

// 已完成的图片
export const USER_IMG_DONE_IMG_STORE_KEY = 'USER_IMG_DONE_IMG_URL'

// 选中的发型信息及颜色信息
export const USER_IMG_SELECTED_INFO_STORE_KEY = 'USER_IMG_SELECTED_INFO'

// 是否显示过提示
export const IS_SHOW_QUESTION_TIPS_KEY = 'IS_SHOW_QUESTION_TIPS'
